




































































import {
  Vue, Component, Watch,
} from 'vue-property-decorator';
import WithdrawalReminderViewModel
  from '@/vue-app/view-models/components/kuspit-dashboard/withdrawals/withdrawal-reminder-view-model';

@Component({ name: 'WithdrawalReminder' })
export default class WithdrawalReminder extends Vue {
  withdrawal_reminder_view_model = Vue.observable(new WithdrawalReminderViewModel(this));

  @Watch('withdrawal_reminder_view_model.is_loading')
  onLoadChange(is_loading: boolean) {
    this.withdrawal_reminder_view_model.emitLoading(is_loading);
  }
}

